var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useContext, useState, useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Order_By } from '../../models/GQLGeneratedModels';
import { useGetAssembliesExtraRoofTypeIdByAPIQuery } from '../../services/AssemblyService';
import { ApplicationContext } from '../ApplicationProvider';
import { ConfigitContext } from '../ConfigitProvider';
import { COMPONENT_MAP } from '../constants/COMPONENT_MAP';
import { TableComponent } from '../shared/TableComponent/TableComponent';
import theme from '../../theme';
import { styled, Typography } from '@mui/material';
import '../shared/DialogComponent/Dialog.scss';
import { AssemblyDetail } from './AssemblyDetail';
import { Link } from '@mui/material';
import { TextOnlyComponent } from '../shared/TextOnlyComponent/TextOnlyComponent';
import { ErrorModalComponent } from '../shared/ErrorModalComponent/ErrorModalComponent';
import { Dialog } from '../shared/DialogComponent/Dialog';
import { isRNDM } from '../../utils/RNDMUtilities';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
var HeaderTypography = styled(Typography)({ '&.MuiTypography-root': { color: theme.palette.rnMisc.white } });
export var RoofTypeAssemblyView = function (_a) {
    var layerConfigId = _a.layerConfigId, count = _a.count, label = _a.label, children = _a.children;
    var _data$navassembly_api;
    var navigate = useNavigate();
    var location = useLocation();
    var urlParams = new URLSearchParams(location.search);
    var _b = useContext(ApplicationContext), itemOffset = _b.itemOffset, itemsPerPage = _b.itemsPerPage, setItemOffset = _b.setItemOffset, setItemsPerPage = _b.setItemsPerPage, filters = _b.filters, setDialog = _b.setDialog;
    var _c = useContext(ConfigitContext), layers = _c.layers, manufacturerProduct = _c.manufacturerProduct, excludedLayerIds = _c.excludedLayerIds;
    var _d = useState(false), showAssemblyDetail = _d[0], setShowAssemblyDetail = _d[1];
    var navAssemblyId = useState(0)[0];
    var _e = useState(isRNDM ? COMPONENT_MAP.PrivateRoofTypeAssemblyView.colHeads : COMPONENT_MAP.RoofTypeAssemblyView.colHeads), columnHeaders = _e[0], setColumnHeaders = _e[1];
    var _f = useState('Assembly #'), fieldSort = _f[0], setFieldSort = _f[1];
    var _g = useState('asc'), sortDir = _g[0], setSortDir = _g[1];
    var _h = useState({ AssemblyId: Order_By.Asc, CoverSubassemblyId: Order_By.Asc, DeckSubassemblyId: Order_By.Asc }), orderbyInfo = _h[0], setOrderbyInfo = _h[1];
    var setTriggerAssemblyList = useContext(ApplicationContext).setTriggerAssemblyList;
    var _j = useContext(ApplicationContext), numShowResult = _j.numShowResult, setNumShowResult = _j.setNumShowResult;
    var _k = useGetAssembliesExtraRoofTypeIdByAPIQuery(layerConfigId, layers, excludedLayerIds, manufacturerProduct, itemsPerPage, itemOffset, orderbyInfo, filters), data = _k.data, loading = _k.loading, error = _k.error;
    var navigateToDetail = function (navAssemblyId, e) { if (e && e.ctrlKey) {
        window.open("/assemblyDetail/".concat(navAssemblyId, "?").concat(urlParams.toString()), "_blank");
    }
    else {
        navigate("/assemblyDetail/".concat(navAssemblyId, "?").concat(urlParams.toString()));
        setShowDialog(false);
    } };
    useEffect(function () { if (error) {
        setDialog(/*#__PURE__*/ _jsx(Dialog, { label: "An Error Occurred", children: /*#__PURE__*/ _jsx(ErrorModalComponent, {}) }));
        setShowDialog(true);
    } }, [error]);
    var handleBackClick = function () { setShowAssemblyDetail(false); }; // Invoke when user click to change different page size
    var handlePageSizeChange = function (event) {
        var newPageSize = parseInt(event.target.value);
        setItemsPerPage(newPageSize);
        setItemOffset(0); // Reset to be the first page
        setTriggerAssemblyList(true);
        setNumShowResult(numShowResult + 1);
    }; // Invoke when user click to request another page.
    var handlePageClick = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var newOffset;
        return __generator(this, function (_a) {
            if (!count)
                return [2 /*return*/];
            newOffset = event.selected * itemsPerPage % count;
            setItemOffset(newOffset);
            setTriggerAssemblyList(true);
            setNumShowResult(numShowResult + 1);
            return [2 /*return*/];
        });
    }); };
    var handleSort = function (field) {
        var headers = isRNDM ? __spreadArray([], COMPONENT_MAP.PrivateRoofTypeAssemblyView.colHeads, true) : __spreadArray([], COMPONENT_MAP.RoofTypeAssemblyView.colHeads, true);
        var newSortDir;
        if (fieldSort === field) {
            newSortDir = sortDir === 'asc' ? 'desc' : 'asc';
            for (var i = 0; i < headers.length; i++) {
                if (headers[i].className !== 'notvisible') {
                    if (headers[i].name === field) {
                        headers[i].className = newSortDir === 'asc' ? 'th-inner sortable both sorted asc' : 'th-inner sortable both sorted desc';
                    }
                    else {
                        headers[i].className = 'th-inner sortable both unsorted';
                    }
                }
            }
        }
        else {
            newSortDir = 'asc';
            for (var i = 0; i < headers.length; i++) {
                if (headers[i].className !== 'notvisible') {
                    if (headers[i].name === field) {
                        headers[i].className = 'th-inner sortable both sorted asc';
                    }
                    else {
                        headers[i].className = 'th-inner sortable both unsorted';
                    }
                }
            }
        } // Get order_by variable
        var orderBy;
        var orderByType = newSortDir === 'asc' ? Order_By.Asc : Order_By.Desc;
        switch (field) {
            case 'Assembly #':
                orderBy = { AssemblyId: orderByType, CoverSubassemblyId: orderByType, DeckSubassemblyId: orderByType };
                break;
            case 'Cover':
                orderBy = { AssemblyTypeCode: orderByType };
                break;
            case 'Application':
                orderBy = { AssemblyApplicationTypeCode: orderByType };
                break;
            case 'Securement':
                orderBy = { CoverSecurementMethodCode: orderByType };
                break;
            case 'Deck':
                orderBy = { DeckTypeCode: orderByType };
                break;
            case 'Wind Uplift':
                orderBy = { WindUplift: orderByType };
                break;
            case 'I/Fire':
                orderBy = { IntFireRatingCode: orderByType };
                break;
            case 'E/Fire':
                orderBy = { ExtFireRatingCode: orderByType };
                break;
            case 'Slope':
                orderBy = { Slope: orderByType };
                break;
            case 'Hail':
                orderBy = { HailRatingCode: orderByType };
                break;
            case 'Status':
                orderBy = { StatusId: orderByType };
                break;
            case 'Lock':
                orderBy = { LockStatusCode: orderByType };
                break;
            default: orderBy = { AssemblyId: Order_By.Asc, CoverSubassemblyId: Order_By.Asc, DeckSubassemblyId: Order_By.Asc };
        }
        setOrderbyInfo(orderBy); //console.log(headers);
        setFieldSort(field);
        setSortDir(newSortDir);
        setColumnHeaders(headers);
        setTriggerAssemblyList(true);
        setNumShowResult(numShowResult + 1);
    };
    var setShowDialog = useContext(ApplicationContext).setShowDialog;
    useEffect(function setupListener() { function handleBackButton() { setShowDialog(false); } window.addEventListener('popstate', handleBackButton); return function cleanupListener() { window.removeEventListener('popstate', handleBackButton); }; }, []);
    return /*#__PURE__*/ _jsxs("div", { id: "roofnav_results", className: "p-3", children: [/*#__PURE__*/ _jsx("div", { className: "p-3", children: /*#__PURE__*/ _jsx("div", { className: "modal-header bg-dialog-steel align-items-center p-0", children: /*#__PURE__*/ _jsx(HeaderTypography, { className: 'ml-3 py-2', fontFamily: 'Inter', fontSize: 24, fontWeight: 600, children: label }) }) }), !showAssemblyDetail ? /*#__PURE__*/ _jsxs(_Fragment, { children: [/*#__PURE__*/ _jsx("div", { className: "col px-4 my-1 text-right", children: /*#__PURE__*/ _jsx(Link, { onClick: function () { return setShowDialog(false); }, children: /*#__PURE__*/ _jsx(TextOnlyComponent, { buttonText: 'Back', iconName: 'arrow_left' }) }) }), /*#__PURE__*/ _jsx(TableComponent, { loading: loading, count: count, offset: itemOffset, limit: itemsPerPage, handlePageSizeChange: handlePageSizeChange, handlePageClick: handlePageClick, handleSort: handleSort, colHeads: columnHeaders, navigateToDetail: navigateToDetail, rows: data && ((_data$navassembly_api = data.navassembly_api_search) === null || _data$navassembly_api === void 0 ? void 0 : _data$navassembly_api.map(function (navAssembly) { var row = [], key = { navAssemblyId: navAssemblyId }; row.push(navAssembly === null || navAssembly === void 0 ? void 0 : navAssembly.NavAssemblyId.toString()); row.push(navAssembly === null || navAssembly === void 0 ? void 0 : navAssembly.NavAssemblyName); if (isRNDM) {
                            row.push((navAssembly === null || navAssembly === void 0 ? void 0 : navAssembly.StatusId.toString()) === '3' ? 'Delisted' : 'Active');
                        } ; row.push(navAssembly === null || navAssembly === void 0 ? void 0 : navAssembly.AssemblyTypeCode); row.push(navAssembly === null || navAssembly === void 0 ? void 0 : navAssembly.AssemblyApplicationTypeCode); row.push(navAssembly === null || navAssembly === void 0 ? void 0 : navAssembly.CoverSecurementMethodCode); row.push(navAssembly === null || navAssembly === void 0 ? void 0 : navAssembly.DeckTypeCode); row.push(navAssembly === null || navAssembly === void 0 ? void 0 : navAssembly.WindUplift); row.push(navAssembly === null || navAssembly === void 0 ? void 0 : navAssembly.IntFireRatingCode); row.push(navAssembly === null || navAssembly === void 0 ? void 0 : navAssembly.ExtFireRatingCode); row.push(navAssembly === null || navAssembly === void 0 ? void 0 : navAssembly.Slope); row.push(navAssembly === null || navAssembly === void 0 ? void 0 : navAssembly.HailRatingCode); return row; })) })] }) : /*#__PURE__*/ _jsx(AssemblyDetail, { navAssemblyId: navAssemblyId, handleBackClick: handleBackClick }), /*#__PURE__*/ _jsx("div", { className: "clearfix" })] });
};
